import * as types from '@/store/types'
export default {
    moduleGroups: state => {
        return state.moduleGroups
    },
    modelDefault: state => {
        return state.modelDefault
    },
    moduleGroupsForSelectGroup: state => {
        let array = [{ id: 0, title: 'Без группы' }]
        return array.concat(state.moduleGroups)
    },
    getModuleGroupById: state => id => {
        return state.find(moduleGroup => moduleGroup.id === id)
    }
}
